import { px } from '../../utils/selectorsUtils'
import { createCssCompNode } from '../cssCompNode'
import { envRefs } from '@wix/thunderbolt-catharsis'

export const placeholder = createCssCompNode('compsMeasuresCss', 'placeholder', {
	getDependencies: () => ({
		experiments: envRefs.experiments,
	}),
	toViewItem: (component, deps) => {
		const { experiments } = deps
		const isRemoveHeaderFooterWrappersOpen = experiments['specs.thunderbolt.removeHeaderFooterWrappers']

		if (
			!isRemoveHeaderFooterWrappersOpen &&
			component.layout.fixedPosition &&
			(component.componentType === 'FooterContainer' || component.componentType === 'HeaderContainer')
		) {
			return { height: px(component.layout.height) }
		}

		return null
	},
})
